export default __webpack_public_path__ + "static/media/LG-logo.194faf95.svg";